import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-4" }
const _hoisted_7 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_10 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_11 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_12 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_13 = { class: "d-flex justify-content-center" }
const _hoisted_14 = { class: "row mt-4" }
const _hoisted_15 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_18 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_19 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_20 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_21 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_AccountWidget = _resolveComponent("AccountWidget")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.amount")) + ":", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`amount`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.amount) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  type: "text",
                  id: "amount"
                }, null, 2), [
                  [_vModelText, _ctx.form.amount]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.from_account")) + ":", 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "btn w-100 btn-outline-dark text-capitalize-first",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleFromType()), ["prevent"]))
            }, _toDisplayString(_ctx.helper.trans(`labels.${_ctx.form.fromAccountType}`)), 1)
          ])
        ]),
        (_ctx.form.fromAccountType !== 'system')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`fromAccountId`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.fromAccount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.fromAccount) = $event)),
                      options: _ctx.fromAccounts,
                      "custom-label": (opt) => _ctx.labelFor(_ctx.form.fromAccountType, opt),
                      "track-by": "id",
                      "select-label": "Select",
                      "open-direction": "bottom",
                      multiple: false,
                      searchable: true,
                      loading: _ctx.isLoading,
                      "internal-search": false,
                      "clear-on-select": true,
                      "close-on-select": true,
                      "options-limit": 100,
                      limit: 1000,
                      "show-no-results": false,
                      "hide-selected": false,
                      onSearchChange: _ctx.asyncFindFromAccounts
                    }, null, 8, ["class", "modelValue", "options", "custom-label", "loading", "onSearchChange"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.fromAccount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_AccountWidget, {
                    "show-icon": true,
                    account: _ctx.form.fromAccount?.hasOwnProperty('account') ? _ctx.form.fromAccount.account : _ctx.form.fromAccount
                  }, null, 8, ["account"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans("labels.to_account")) + ":", 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "btn w-100 btn-outline-dark text-capitalize-first",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toggleToType()), ["prevent"]))
            }, _toDisplayString(_ctx.helper.trans(`labels.${_ctx.form.toAccountType}`)), 1)
          ])
        ]),
        (_ctx.form.toAccountType !== 'system')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`toAccountId`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      class: _normalizeClass(parentProps.class),
                      modelValue: _ctx.form.toAccount,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.toAccount) = $event)),
                      options: _ctx.toAccounts,
                      "custom-label": (opt) => _ctx.labelFor(_ctx.form.toAccountType, opt),
                      "track-by": "id",
                      "select-label": "Select",
                      "open-direction": "bottom",
                      multiple: false,
                      searchable: true,
                      loading: _ctx.isLoading,
                      "internal-search": false,
                      "clear-on-select": true,
                      "close-on-select": true,
                      "options-limit": 100,
                      limit: 1000,
                      "show-no-results": false,
                      "hide-selected": false,
                      onSearchChange: _ctx.asyncFindToAccounts
                    }, null, 8, ["class", "modelValue", "options", "custom-label", "loading", "onSearchChange"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.toAccount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_AccountWidget, {
                    "show-icon": true,
                    account: _ctx.form.toAccount?.hasOwnProperty('account') ? _ctx.form.toAccount.account : _ctx.form.toAccount
                  }, null, 8, ["account"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}